var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#A5ABDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0599 11.9994L15.3599 9.69937C15.6499 9.40937 15.6499 8.92937 15.3599 8.63938C15.0699 8.34938 14.5899 8.34938 14.2999 8.63938L11.9999 10.9394L9.69986 8.63938C9.40986 8.34938 8.92986 8.34938 8.63986 8.63938C8.34986 8.92937 8.34986 9.40937 8.63986 9.69937L10.9399 11.9994L8.63986 14.2994C8.34986 14.5894 8.34986 15.0694 8.63986 15.3594C8.78986 15.5094 8.97986 15.5794 9.16986 15.5794C9.35986 15.5794 9.54986 15.5094 9.69986 15.3594L11.9999 13.0594L14.2999 15.3594C14.4499 15.5094 14.6399 15.5794 14.8299 15.5794C15.0199 15.5794 15.2099 15.5094 15.3599 15.3594C15.6499 15.0694 15.6499 14.5894 15.3599 14.2994L13.0599 11.9994Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.7e888530f05ba558a2e032cc3b578991.svg";
export { ForwardRef as ReactComponent };